import React from 'react'

class AppBarComponent extends React.Component {
  state = {}

  render() {
    const { borderBottom, children, theme } = this.props

    let style = {
      borderBottom: '2px solid rgba(1, 1, 1, 0)',
    }
    if (borderBottom === true) {
      style = {
        borderBottom: `2px solid ${theme.palette.primary.main}`,
      }
    }

    return (
      <div
        style={{
          zIndex: 2000,
          backgroundColor: 'white',
          boxShadow:
            '0px 2px 2px -1px rgba(0, 0, 0, 0.1), 0px 4px 7px 0px rgba(0, 0, 0, 0.04), 0px 1px 10px 0px rgba(0, 0, 0, 0.01)',
        }}
      >
        <div style={{ paddingLeft: '0px', paddingRight: '0px', padding: 12 }}>
          {children}
        </div>
      </div>
    )
  }
}

export default AppBarComponent
